import { RESPONSE } from '@nguniversal/express-engine/tokens'
import {Component, OnInit, Inject, Optional, NgModule} from '@angular/core';
import { Response } from 'express'
import {CommonModule} from '@angular/common';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {RouterModule} from '@angular/router';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
    private response: Response;

    constructor(@Optional() @Inject(RESPONSE) response: any) {
        this.response = response;
    }

    ngOnInit(): void {
        if (this.response) {
            this.response.status(404);
        }
    }

}

@NgModule({
    declarations: [PageNotFoundComponent],
    exports: [PageNotFoundComponent],
    imports: [
        CommonModule,
        AngularSvgIconModule,
        RouterModule
    ]
})

export class PageNotFoundModule {
}
